import { useSyncExternalStore, useCallback } from 'react'

/**
 * Reactively tracks a CSS media query match.
 * Returns true when the query matches, false otherwise.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (callback: () => void) => {
      const mql = window.matchMedia(query)
      mql.addEventListener('change', callback)
      return () => mql.removeEventListener('change', callback)
    },
    [query],
  )

  const getSnapshot = useCallback(() => window.matchMedia(query).matches, [query])

  const getServerSnapshot = useCallback(() => false, [])

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot)
}

/** True when viewport is >= 768px (Tailwind `md` breakpoint). */
export function useIsDesktop(): boolean {
  return useMediaQuery('(min-width: 768px)')
}
